<template>
  <form v-if="!loading" @submit.prevent="onSubmit">
    <div class="row">
      <div class="col-12">
        <b-checkbox v-model="featured.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-12">
        <app-input
          v-model="featured.url"
          label="Link"
          :errors="errors.url"
        ></app-input>
        <b-checkbox v-model="featured.new_window"
          >Abrir em nova janela</b-checkbox
        >
      </div>
      <div class="col-xl-6 col-lg-12">
        <app-file-picker
          v-model="imageToCrop"
          label="Imagem"
          flag="featured-banner"
          accept="image/*"
          @fileDeleted="() => (this.featured.image = '')"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="imageToCrop"
          :src="imageToCrop"
          :aspectRatio="8.36 / 1"
          @croppedImage="onImageCropped"
        ></app-image-cropper>

        <img
          v-if="featured.image"
          :src="featured.image"
          alt="Imagem"
          class="featured-preview"
        />
      </div>
      <div class="col-xl-6 col-lg-12">
        <app-file-picker
          v-model="mobileImageToCrop"
          label="Imagem Mobile"
          flag="featured-banner-mobile"
          accept="image/*"
          @fileDeleted="() => (this.featured.image_mobile = '')"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="mobileImageToCrop"
          :src="mobileImageToCrop"
          :aspectRatio="1.91 / 1"
          @croppedImage="onMobileImageCropped"
        ></app-image-cropper>

        <img
          v-if="featured.image_mobile"
          :src="featured.image_mobile"
          alt="Imagem Mobile"
          class="featured-preview"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import FeaturedBannersService from '@/services/featured-banner.service';
import AppImageCropper from '@/components/AppComponents/AppCropperImage.vue';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'featured-banners-form',
  props: ['id', 'errors', 'saving'],
  components: { AppImageCropper },
  data: () => {
    return {
      imageToCrop: null,
      mobileImageToCrop: null,
      loading: true,
      featured: {
        active: true,
        new_window: false,
        url: null,
        image: null,
        image_mobile: null,
      },
    };
  },
  validations: {
    featured: {
      image: { required },
      image_mobile: { required },
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.featured);
    },
    loadFeatured(id) {
      FeaturedBannersService.getId(id)
        .then(({ data: featured }) => (this.featured = featured))
        .catch(() => {
          this.toastify('Erro ao tentar carregar Destaque.');
        })
        .finally(() => (this.loading = false));
    },
    onImageCropped(value) {
      this.featured.image = value;
      this.imageToCrop = '';
    },
    onMobileImageCropped(value) {
      this.featured.image_mobile = value;
      this.mobileImageToCrop = '';
    },
  },
  beforeMount() {
    if (this.id) this.loadFeatured(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.featured-preview {
  max-height: 140px;
  object-fit: cover;
}

.message {
  font-style: italic;
  color: var(--color-danger);
  background: none;
}
</style>
